import { gql } from '@apollo/client/core'

/**
 * Bond Input Interface
 * Matches the new column list
 */
export interface BondInput {
  bond_id: string  // Use camelCase
  name: string
  code: string
  invest_amount: number
  interest: number
  interest_amount: number
  coupon_date: String
  payment_type: string
  purchase_type: string
  purchase_date: string
  maturity_date: string
}

/**
 * Query to get all bonds
 */
export const GET_BONDS = gql`
  query Bonds {
    bonds {
      bond_id
      name
      code
      invest_amount
      interest
      interest_amount
      total_interest_paid
      coupon_date
      payment_type
      purchase_type
      purchase_date
      maturity_date
    }
  }
`

/**
 * Mutation to add a new bond
 */
export const ADD_BOND = gql`
  mutation Mutation($input: BondInput!) {
    addBond(input: $input) {
      name
      code
      invest_amount
      interest
      interest_amount
      coupon_date
      payment_type
      purchase_type
      purchase_date
      maturity_date
    }
  }
`

/**
 * Mutation to update an existing bond
 */
export const UPDATE_BOND = gql`
  mutation updateBond($bond_id: ID!, $input: BondInput!) {
    updateBond(bond_id: $bond_id, input: $input) {
      bond_id
      name
      code
      invest_amount
      interest
      interest_amount
      coupon_date
      payment_type
      purchase_type
      purchase_date
      maturity_date
    }
  }
`

/**
 * Mutation to delete a bond
 */
export const DELETE_BOND = gql`
  mutation deleteBond($bond_id: ID!) {
    deleteBond(bond_id: $bond_id) {
      bond_id
    }
  }
`

/**
 * Bond Interest History Table
 */

// GraphQL queries and mutations
export const GET_BOND_INTEREST_HISTORY = gql`
query {
  bondInterestHistories {
    entity_id
    bond_id
    date
    type
    amount
    note
  }
}
`;

export const ADD_BOND_INTEREST_HISTORY = gql`
mutation AddBondInterestHistory($input: BondInterestHistoryInput!) {
  addBondInterestHistory(input: $input) {
    entity_id
    bond_id
    date
    type
    amount
    note
  }
}
`;

export const UPDATE_BOND_INTEREST_HISTORY = gql`
  mutation UpdateBondInterest($entity_id: ID!, $input: BondInterestHistoryInput!) {
    updateBondInterestHistory(entity_id: $entity_id, input: $input) {
      entity_id
      bond_id
      date
      type
      amount
      note
    }
}
`;


export const DELETE_BOND_INTEREST_HISTORY = gql`
mutation DeleteBondInterestHistory($entity_id: ID!) {
  deleteBondInterestHistory(entity_id: $entity_id) {
    entity_id
  }
}
`;